/**
 * Device management contract (TEAM-UX-PRD §6.4). Lists the fleet's devices and
 * revokes a device's active sessions (lost-laptop mitigation). Owner-gated in
 * the route; not an MCP tool.
 */

import { z } from "zod";
import type { Operation } from "../types";

export const teamDeviceSchema = z.object({
  deviceId: z.string(),
  deviceName: z.string().nullable(),
  userId: z.number().nullable(),
  handle: z.string().nullable(),
  paired: z.boolean(),
  activeSessions: z.number(),
  lastSeenAt: z.string().nullable(),
});
export type TeamDevice = z.infer<typeof teamDeviceSchema>;

const listOp: Operation<void, void, void, { devices: TeamDevice[] }> = {
  method: "GET",
  path: () => "/api/devices/list",
  response: z.object({ devices: z.array(teamDeviceSchema) }),
};

const revokeBody = z.object({ deviceId: z.string().min(1) });
const revokeOp: Operation<
  void,
  void,
  z.infer<typeof revokeBody>,
  { ok: boolean; reason?: string }
> = {
  method: "POST",
  path: () => "/api/devices/revoke",
  body: revokeBody,
  response: z.object({ ok: z.boolean(), reason: z.string().optional() }),
  // clears activeSessions / paired on the revoked device row.
  invalidates: [listOp],
};

export const devices = { list: listOp, revoke: revokeOp };
